import HowToRegIcon from '@mui/icons-material/HowToReg';
import CakeIcon from '@mui/icons-material/Cake';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import WebhookIcon from '@mui/icons-material/Webhook';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LabelOffIcon from '@mui/icons-material/LabelOff';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

// Tab colors per spec: cyan/blue for conditions, green for actions.
export const CONDITION_COLOR = '#00acc1';
export const ACTION_COLOR = '#43a047';

// Mime type used to drag palette tiles onto the canvas.
export const PALETTE_DRAG_TYPE = 'application/x-funzone-flow-block';

// The named outputs of a branching block, in the order they sit on the card.
export const SPLIT_BRANCHES = [
  { branch: 'yes', label: 'Ja' },
  { branch: 'no', label: 'Nein' },
];

// Definition of every available canvas block type.
export const BLOCK_TYPES = {
  listSignup: {
    type: 'listSignup',
    kind: 'condition',
    isStart: true,
    title: 'Angemeldet für Liste',
    paletteLabel: 'Angemeldet für beliebige Liste über beliebige Methode',
    color: CONDITION_COLOR,
    Icon: HowToRegIcon,
    defaultConfig: () => ({ listId: null, signupMethod: 'any', includeExistingContacts: false }),
  },
  specialOccasion: {
    type: 'specialOccasion',
    kind: 'condition',
    isStart: false,
    title: 'Besonderer Anlass',
    paletteLabel: 'Besonderer Anlass',
    color: CONDITION_COLOR,
    Icon: CakeIcon,
    defaultConfig: () => ({
      dateField: 'birthdate',
      direction: 'before',
      offsetDays: 21,
      recurrence: 'yearly',
    }),
  },
  wait: {
    type: 'wait',
    kind: 'action',
    isStart: false,
    title: 'Warten',
    paletteLabel: 'Warten/Time Delay',
    color: ACTION_COLOR,
    Icon: HourglassBottomIcon,
    defaultConfig: () => ({ amount: 1, unit: 'days' }),
  },
  issueVoucher: {
    type: 'issueVoucher',
    kind: 'action',
    isStart: false,
    title: 'Gutschein erstellen',
    paletteLabel: 'Gutschein erstellen',
    color: ACTION_COLOR,
    Icon: CardGiftcardIcon,
    defaultConfig: () => ({
      amount: 10,
      validityDays: 30,
      origin: 'welcome_flow',
      codePrefix: 'WEL',
      perEntertainment: false,
      entertainmentIds: [],
    }),
  },
  increaseVoucherValue: {
    type: 'increaseVoucherValue',
    kind: 'action',
    isStart: false,
    title: 'Gutschein erhöhen',
    paletteLabel: 'Gutschein-Wert erhöhen (gleicher Code)',
    color: ACTION_COLOR,
    Icon: TrendingUpIcon,
    defaultConfig: () => ({ voucherBlockId: null, amount: 30 }),
  },
  getresponseSync: {
    type: 'getresponseSync',
    kind: 'action',
    isStart: false,
    title: 'GetResponse-Sync',
    paletteLabel: 'GetResponse: Kontakt + Gutschein-Felder syncen',
    color: ACTION_COLOR,
    Icon: CloudUploadIcon,
    defaultConfig: () => ({
      campaignId: null,
      voucherBlockId: null,
      fieldPrefix: 'birthday',
      linkBaseUrl: '',
    }),
  },
  getresponseTag: {
    type: 'getresponseTag',
    kind: 'action',
    isStart: false,
    title: 'GetResponse-Tag',
    paletteLabel: 'GetResponse: Tag setzen/entfernen (Trigger)',
    color: ACTION_COLOR,
    Icon: BookmarkAddIcon,
    defaultConfig: () => ({ campaignId: null, addTags: [], removeTags: [] }),
  },
  condition: {
    type: 'condition',
    kind: 'condition',
    isStart: false,
    title: 'Bedingung',
    paletteLabel: 'Bedingung (PLZ, Tags, Umsatz, Engagement …)',
    color: CONDITION_COLOR,
    Icon: FilterAltIcon,
    defaultConfig: () => ({
      conditionType: 'zipPrefix',
      zipPrefixes: [],
      entertainmentId: null,
      failAction: 'skipNext',
    }),
  },
  conditionalSplit: {
    type: 'conditionalSplit',
    kind: 'condition',
    isStart: false,
    title: 'Bedingter Split',
    paletteLabel: 'Bedingter Split (Ja/Nein-Verzweigung)',
    color: CONDITION_COLOR,
    Icon: AltRouteIcon,
    // Two named outputs instead of one: the canvas draws a port per branch.
    branches: SPLIT_BRANCHES,
    defaultConfig: () => ({
      conditionType: 'hasTag',
      tags: [],
      yesAction: 'continue',
      noAction: 'continue',
    }),
  },
  bookingCompleted: {
    type: 'bookingCompleted',
    kind: 'condition',
    isStart: true,
    title: 'Buchung abgeschlossen',
    paletteLabel: 'Buchung abgeschlossen',
    color: CONDITION_COLOR,
    Icon: EventAvailableIcon,
    defaultConfig: () => ({
      entertainmentIds: [],
      channels: [],
      onlyFirstBooking: false,
      minTotalAmount: null,
      requireMarketingConsent: true,
    }),
  },
  visitCompleted: {
    type: 'visitCompleted',
    kind: 'condition',
    isStart: true,
    title: 'Besuch beendet',
    paletteLabel: 'Besuch beendet (X Stunden danach)',
    color: CONDITION_COLOR,
    Icon: SportsEsportsIcon,
    defaultConfig: () => ({ entertainmentIds: [], hoursAfter: 2, requireMarketingConsent: true }),
  },
  bookingNoShow: {
    type: 'bookingNoShow',
    kind: 'condition',
    isStart: true,
    title: 'No-Show',
    paletteLabel: 'Buchung als No-Show markiert',
    color: CONDITION_COLOR,
    Icon: PersonOffIcon,
    defaultConfig: () => ({ entertainmentIds: [], requireMarketingConsent: true }),
  },
  abandonedBooking: {
    type: 'abandonedBooking',
    kind: 'condition',
    isStart: true,
    title: 'Buchung abgebrochen',
    paletteLabel: 'Buchung abgebrochen (Warenkorbabbruch)',
    color: CONDITION_COLOR,
    Icon: RemoveShoppingCartIcon,
    defaultConfig: () => ({ entertainmentIds: [], hoursAfter: 3, onlyWithConsent: true }),
  },
  inactivity: {
    type: 'inactivity',
    kind: 'condition',
    isStart: true,
    title: 'Inaktivität',
    paletteLabel: 'Kunde inaktiv seit X Tagen',
    color: CONDITION_COLOR,
    Icon: BedtimeIcon,
    defaultConfig: () => ({ inactiveDays: 180, entertainmentIds: [], requireMarketingConsent: true }),
  },
  consentGranted: {
    type: 'consentGranted',
    kind: 'condition',
    isStart: true,
    title: 'Einwilligung erteilt',
    paletteLabel: 'Marketing-Einwilligung erteilt',
    color: CONDITION_COLOR,
    Icon: VerifiedUserIcon,
    defaultConfig: () => ({ entertainmentIds: [] }),
  },
  tagAdded: {
    type: 'tagAdded',
    kind: 'condition',
    isStart: true,
    title: 'Interner Tag gesetzt',
    paletteLabel: 'Kontakt trägt einen internen Tag',
    color: CONDITION_COLOR,
    Icon: LocalOfferIcon,
    defaultConfig: () => ({ tags: [], requireMarketingConsent: true }),
  },
  occasionDue: {
    type: 'occasionDue',
    kind: 'condition',
    isStart: true,
    title: 'Anlass erreicht',
    paletteLabel: 'Kontakt erreicht heute seinen Anlass (Geburtstag)',
    color: CONDITION_COLOR,
    Icon: EventRepeatIcon,
    defaultConfig: () => ({
      dateField: 'birthdate',
      direction: 'on',
      offsetDays: 0,
      requiredTags: [],
      requireMarketingConsent: true,
    }),
  },
  manualSegment: {
    type: 'manualSegment',
    kind: 'condition',
    isStart: true,
    title: 'Manuelle Auswahl',
    paletteLabel: 'Manuell eingeschriebene Kontakte',
    color: CONDITION_COLOR,
    Icon: GroupAddIcon,
    defaultConfig: () => ({}),
  },
  apiTrigger: {
    type: 'apiTrigger',
    kind: 'condition',
    isStart: true,
    title: 'API-Trigger',
    paletteLabel: 'Externer API-Trigger (Integrationen)',
    color: CONDITION_COLOR,
    Icon: WebhookIcon,
    defaultConfig: () => ({ triggerSecret: '' }),
  },
  abSplit: {
    type: 'abSplit',
    kind: 'action',
    isStart: false,
    title: 'A/B-Test',
    paletteLabel: 'A/B-Test (Split)',
    color: ACTION_COLOR,
    Icon: CallSplitIcon,
    defaultConfig: () => ({ percentageA: 50 }),
  },
  addToList: {
    type: 'addToList',
    kind: 'action',
    isStart: false,
    title: 'Zur Liste hinzufügen',
    paletteLabel: 'Zur Liste hinzufügen',
    color: ACTION_COLOR,
    Icon: PlaylistAddIcon,
    defaultConfig: () => ({ listId: null }),
  },
  removeFromList: {
    type: 'removeFromList',
    kind: 'action',
    isStart: false,
    title: 'Aus Liste entfernen',
    paletteLabel: 'Aus Liste entfernen',
    color: ACTION_COLOR,
    Icon: PlaylistRemoveIcon,
    defaultConfig: () => ({ listId: null }),
  },
  addTag: {
    type: 'addTag',
    kind: 'action',
    isStart: false,
    title: 'Tag hinzufügen',
    paletteLabel: 'Tag hinzufügen',
    color: ACTION_COLOR,
    Icon: LocalOfferIcon,
    defaultConfig: () => ({ tags: [] }),
  },
  removeTag: {
    type: 'removeTag',
    kind: 'action',
    isStart: false,
    title: 'Tag entfernen',
    paletteLabel: 'Tag entfernen',
    color: ACTION_COLOR,
    Icon: LabelOffIcon,
    defaultConfig: () => ({ tags: [] }),
  },
  notifyTeam: {
    type: 'notifyTeam',
    kind: 'action',
    isStart: false,
    title: 'Team benachrichtigen',
    paletteLabel: 'Team benachrichtigen (intern)',
    color: ACTION_COLOR,
    Icon: NotificationsActiveIcon,
    defaultConfig: () => ({ recipients: [], subject: '', note: '' }),
  },
};

export const FLOW_STATUS_META = {
  draft: { label: 'Entwurf', color: 'default' },
  active: { label: 'Aktiv', color: 'success' },
  paused: { label: 'Pausiert', color: 'warning' },
};

const WAIT_UNITS = {
  minutes: ['Minute', 'Minuten'],
  hours: ['Stunde', 'Stunden'],
  days: ['Tag', 'Tage'],
};

// Short German description of a condition, shared by the "Bedingung" block and
// the "Bedingter Split".
const getConditionSummary = config => {
  switch (config.conditionType) {
    case 'zipPrefix': {
      const prefixes = (config.zipPrefixes || []).filter(Boolean);
      return prefixes.length ? `PLZ beginnt mit ${prefixes.join(', ')}` : 'Keine PLZ-Präfixe';
    }
    case 'visitedEntertainment':
      return 'Entertainment bereits besucht';
    case 'notVisitedEntertainment':
      return 'Entertainment noch nicht besucht';
    case 'hasTag':
      return `Hat Tag: ${(config.tags || []).join(', ') || '—'}`;
    case 'notHasTag':
      return `Hat Tag nicht: ${(config.tags || []).join(', ') || '—'}`;
    case 'bookingCountAtLeast':
      return `Mind. ${Number(config.minBookings) || 1} Buchungen`;
    case 'revenueAtLeast':
      return `Mind. ${Number(config.minRevenue) || 0} € Umsatz`;
    case 'lastVisitWithinDays':
      return `Besuch in den letzten ${Number(config.days) || 0} Tagen`;
    case 'lastVisitOlderThanDays':
      return `Kein Besuch seit ${Number(config.days) || 0} Tagen`;
    case 'redeemedVoucherFromBlock':
      return 'Gutschein eingelöst';
    case 'notRedeemedVoucherFromBlock':
      return 'Gutschein nicht eingelöst';
    case 'redeemedCampaignCode':
      return `Kampagnencode eingelöst: ${config.campaignCode || '—'}`;
    case 'ageBetween': {
      const min = config.minAge != null ? config.minAge : '–';
      const max = config.maxAge != null ? config.maxAge : '–';
      return `Alter ${min} bis ${max}`;
    }
    default:
      return 'Keine Bedingung ausgewählt';
  }
};

// One-line German summary of a block's current configuration for the canvas card.
export const getBlockSummary = (block, { lists = [] } = {}) => {
  const config = block.config || {};
  switch (block.type) {
    case 'listSignup': {
      const list = lists.find(entry => entry._id === config.listId);
      return list ? `Liste: ${list.name}` : 'Keine Liste ausgewählt';
    }
    case 'specialOccasion': {
      const recurrence = config.recurrence === 'yearly' ? ' · jährlich' : '';
      if (config.direction === 'on') return `Am Geburtstag${recurrence}`;
      const days = Number(config.offsetDays) || 0;
      const dayWord = days === 1 ? 'Tag' : 'Tage';
      const directionWord = config.direction === 'after' ? 'nach' : 'vor';
      return `${days} ${dayWord} ${directionWord} Geburtstag${recurrence}`;
    }
    case 'wait': {
      const amount = Number(config.amount) || 0;
      const [singular, plural] = WAIT_UNITS[config.unit] || WAIT_UNITS.days;
      return `${amount} ${amount === 1 ? singular : plural}`;
    }
    case 'issueVoucher': {
      const amount = Number(config.amount) || 0;
      const days = Number(config.validityDays) || 0;
      const scope = config.perEntertainment ? ' je Entertainment' : '';
      return `${amount} €${scope} · ${days} Tage gültig`;
    }
    case 'increaseVoucherValue': {
      const amount = Number(config.amount) || 0;
      return config.voucherBlockId
        ? `Auf ${amount} € erhöhen (gleicher Code)`
        : 'Kein Gutschein-Block ausgewählt';
    }
    case 'getresponseSync': {
      const prefix = config.fieldPrefix || 'birthday';
      const base = config.voucherBlockId ? `Gutschein-Felder (${prefix}_*)` : 'Nur Kontakt anlegen';
      return config.campaignId ? base : `${base} · Standard-Liste`;
    }
    case 'getresponseTag': {
      const addTags = (config.addTags || []).filter(Boolean);
      const removeTags = (config.removeTags || []).filter(Boolean);
      const parts = [];
      if (addTags.length) parts.push(`+ ${addTags.join(', ')}`);
      if (removeTags.length) parts.push(`− ${removeTags.join(', ')}`);
      return parts.length ? parts.join(' · ') : 'Keine Tags konfiguriert';
    }
    case 'condition':
      return getConditionSummary(config);
    case 'conditionalSplit': {
      const branchLabel = action => (action === 'exit' ? 'Ende' : 'weiter');
      const yes = branchLabel(config.yesAction);
      const no = branchLabel(config.noAction);
      return `${getConditionSummary(config)} · Ja → ${yes}, Nein → ${no}`;
    }
    case 'bookingCompleted': {
      const parts = [];
      if (config.onlyFirstBooking) parts.push('nur Erstbuchung');
      if (config.minTotalAmount != null && config.minTotalAmount !== '')
        parts.push(`ab ${config.minTotalAmount} €`);
      if ((config.channels || []).length) parts.push(config.channels.join('/'));
      return parts.length ? parts.join(' · ') : 'Jede bestätigte Buchung';
    }
    case 'visitCompleted':
      return `${Number(config.hoursAfter) || 0} Std. nach Besuchsende`;
    case 'bookingNoShow':
      return 'Nach No-Show-Markierung';
    case 'abandonedBooking':
      return `${Number(config.hoursAfter) || 0} Std. nach Abbruch${config.onlyWithConsent !== false ? ' · nur mit Einwilligung' : ''}`;
    case 'inactivity':
      return `Inaktiv seit ${Number(config.inactiveDays) || 0} Tagen`;
    case 'tagAdded': {
      const triggerTags = (config.tags || []).filter(Boolean);
      return triggerTags.length ? triggerTags.join(', ') : 'Kein Tag eingetragen';
    }
    case 'consentGranted':
      return 'Bei neuer Marketing-Einwilligung';
    case 'occasionDue': {
      const gateTags = (config.requiredTags || []).filter(Boolean);
      const gate = gateTags.length ? ` · nur ${gateTags.join(', ')}` : '';
      if (config.direction === 'on') return `Am Geburtstag${gate}`;
      const occasionDays = Number(config.offsetDays) || 0;
      const dayWord = occasionDays === 1 ? 'Tag' : 'Tage';
      const directionWord = config.direction === 'after' ? 'nach' : 'vor';
      return `${occasionDays} ${dayWord} ${directionWord} Geburtstag${gate}`;
    }
    case 'manualSegment':
      return 'Manuell über „Kontakte einschreiben“';
    case 'apiTrigger':
      return config.triggerSecret ? 'Secret gesetzt' : 'Secret fehlt';
    case 'abSplit': {
      const percentageA = Number(config.percentageA) || 50;
      return `Variante A ${percentageA} % · Variante B ${100 - percentageA} %`;
    }
    case 'addToList':
    case 'removeFromList': {
      const list = lists.find(entry => entry._id === config.listId);
      return list ? `Liste: ${list.name}` : 'Keine Liste ausgewählt';
    }
    case 'addTag':
    case 'removeTag':
      return (config.tags || []).join(', ') || 'Keine Tags';
    case 'notifyTeam':
      return (config.recipients || []).join(', ') || 'Keine Empfänger';
    default:
      return '';
  }
};
